import request from '@/utils/request'
import { resolveApiBase } from '@/utils/apiBase'

/** 模板文件下载/预览 URL（需带 Authorization） */
export function getTemplateFileUrl(id) {
  const base = resolveApiBase()
  return `${base}/api/contract-template/${id}/file`
}

export function getMergePlaceholders() {
  return request({
    url: '/api/contract-template/merge-placeholders',
    method: 'get'
  })
}

export function getTemplatePage(params) {
  return request({
    url: '/api/contract-template/page',
    method: 'get',
    params
  })
}

export function getTemplate(id) {
  return request({
    url: `/api/contract-template/${id}`,
    method: 'get'
  })
}

export function saveTemplate(data) {
  return request({
    url: '/api/contract-template',
    method: 'post',
    data
  })
}

export function updateTemplate(id, data) {
  return request({
    url: `/api/contract-template/${id}`,
    method: 'put',
    data
  })
}

export function deleteTemplate(id) {
  return request({
    url: `/api/contract-template/${id}`,
    method: 'delete'
  })
}

export function uploadTemplateFile(id, file) {
  const fd = new FormData()
  fd.append('file', file)
  return request({
    url: `/api/contract-template/${id}/upload`,
    method: 'post',
    data: fd,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
